// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

/**
 * Standard tenant configuration for non-admin users
 * Used by: LLM Usage Reports, API Analytics, Business Metrics Dashboard, Admin Dashboard
 */
export const STANDARD_TENANT_CONFIG = {
  includeAll: true,
  allLabel: "All Tenants",
  autoFetch: true,
};

/**
 * Admin tenant configuration (conditional based on admin status)
 * Used by: Financial Overview, Financial Forecast, Risk Analysis, Bookings
 */
export const getAdminTenantConfig = (isAdminUser) => ({
  includeAll: isAdminUser,
  allLabel: "All Tenants",
  autoFetch: isAdminUser,
  status: "active",
  search: "",
  limit: 100,
  sort_by: "name",
  sort_order: "asc",
});
